export class UpdateControlViolationInput {
    'id';
    'resourceId';
    'muted';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "muted",
            "baseName": "muted",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateControlViolationInput.attributeTypeMap;
    }
    constructor() {
    }
}
